import http from 'conversations-http/clients/http';
export const createSpaceClient = data => {
  return http.post('hd-spaces/v1/spaces', {
    data: Object.assign({
      spaceFilterType: 'TEAM'
    }, data)
  });
};